export default "__VITE_ASSET__Cil_IQh___"